import FeaturedProductsSection from "../components/home/FeaturedProductsSection";
import LatestProducts from "../components/home/LatestProducts";
import ShopexOffer from "../components/home/ShopexOffer";
import UniqueFeatures from "../components/home/UniqueFeatures";
import TrendingProducts from "../components/home/TrendingProducts";
import DiscountItems from "../components/home/DiscountItems";
import TopCategories from "../components/home/TopCategories";
import SubscribeSection from "../components/home/SubscribeSection";
import Collaboration from "../components/Collaboration";
import LatestBlog from "../components/home/LatestBlog";
import Hero from "../components/home/Hero";

export default function Home() {
  return (
    <>
      <Hero />
      <FeaturedProductsSection />
      <LatestProducts />
      <ShopexOffer />
      <UniqueFeatures />
      <TrendingProducts />
      <DiscountItems />
      <TopCategories />
      <SubscribeSection />
      <Collaboration />
      <LatestBlog />
    </>
  );
}
